<template>
  <a-modal
      @ok="onOk"
      @cancel="onCancel"
      :title="title"
      :cancelText="cancelText || $t('modal.close')"
      :okText="okText || $t('modal.apply')"
      :visible="visible"
      :wrapClassName="wrapClassName"
  >
    <slot />
    <template #footer v-if="customFooter">
      <slot name="footer" v-bind:close="onCancel" v-bind:ok="onOk" />
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "Modal",
  // Класс, заданный на этой обёртке, до диалога не доходит — для него нужен wrapClassName
  props: ['cancelText', 'okText', 'customFooter', 'title', 'visible', 'wrapClassName'],
  methods: {
    onOk() {
      this.$emit('ok');
      this.onCancel();
    },

    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
